import {
  possibleRemainingSteps,
  inputForCustomFieldDefinition,
} from './helpers';

describe('Dynamic form helpers', () => {
  describe('possibleRemainingSteps', () => {
    describe('standard inputs', () => {
      const types = [
        'CustomFieldDefinitions::TextField',
        'CustomFieldDefinitions::NumberField',
        'CustomFieldDefinitions::DateField',
        'CustomFieldDefinitions::UrlField',
        'CustomFieldDefinitions::SelectConstant',
        'CustomFieldDefinitions::SelectEditable',
      ];

      types.forEach(type => {
        const definition = { type: type };
        const inputWrapper = document.createElement('div');

        describe('when input large and input small', () => {
          inputWrapper.innerHTML = `
            <div>
              <input class="input-small" />
              <input class="input-xxlarge" />
            </div>
          `;

          const input = inputForCustomFieldDefinition(definition, inputWrapper);

          it('finds the xxlarge input', () => {
            expect(input.nodeName).toEqual('INPUT');
            expect(input.className).toEqual('input-xxlarge');
          });
        });

        describe('when there is only a small input', () => {
          inputWrapper.innerHTML = `
            <div>
              <input class="input-small" />
            </div>
          `;

          const input = inputForCustomFieldDefinition(definition, inputWrapper);

          it('finds the small input', () => {
            expect(input.nodeName).toEqual('INPUT');
            expect(input.className).toEqual('input-small');
          });
        });

        describe('when there is not match', () => {
          inputWrapper.innerHTML = `
            <div>
              <input class="not-the-input-youre-looking-for" />
            </div>
          `;

          const input = inputForCustomFieldDefinition(definition, inputWrapper);

          it('is nu', () => {
            expect(input).toEqual(null);
          });
        });
      });
    });

    describe('selectro-v2 fields', () => {
      const types = [
        'CustomFieldDefinitions::SelectMultipleConstant',
        'CustomFieldDefinitions::SelectMultipleEditable',
        'CustomFieldDefinitions::LinkMany',
        'CustomFieldDefinitions::LinkOne',
      ];

      types.forEach(type => {
        const definition = { type: type };
        const inputWrapper = document.createElement('div');

        describe('when there are selectro_v2 hidden inputs', () => {
          inputWrapper.innerHTML = `
            <div>
              <div class="SelectroV2__mount-container">
                <input class="SelectroV2__hidden-selected-input" value="foo" />
                <input class="SelectroV2__hidden-selected-input" value="foo-2" />
              </div>
            </div>
          `;

          const input = inputForCustomFieldDefinition(definition, inputWrapper);

          it('finds their value', () => {
            expect(input.value).toEqual(['foo', 'foo-2']);
          });
        });

        describe('when there is not match', () => {
          inputWrapper.innerHTML = `
            <div>
              <input />
            </div>
          `;

          const input = inputForCustomFieldDefinition(definition, inputWrapper);

          it('is null', () => {
            expect(input).toEqual(null);
          });
        });
      });
    });

    describe('node fields', () => {
      const definition = { type: 'CustomFieldDefinitions::NoteField' };
      const inputWrapper = document.createElement('div');

      describe('when there is editor data', () => {
        inputWrapper.innerHTML = `
          <div>
            <input value='{"object":"value","document":{"object":"document","data":{},"nodes":[{"object":"block","type":"paragraph","nodes":[{"object":"text","text":"foo"}]}]}}' />
          </div>
        `;

        const result = inputForCustomFieldDefinition(definition, inputWrapper);

        it('returns the value', () => {
          expect(result.value).toEqual(
            '{"object":"value","document":{"object":"document","data":{},"nodes":[{"object":"block","type":"paragraph","nodes":[{"object":"text","text":"foo"}]}]}}'
          );
        });
      });

      describe('when the document is empty', () => {
        inputWrapper.innerHTML = `
            <div>
              <input value='{"object":"value","document":{"object":"document","data":{},"nodes":[{"object":"block","type":"paragraph","nodes":[{"object":"text","text":""}]}]}}' />
            </div>
          `;

        const result = inputForCustomFieldDefinition(definition, inputWrapper);

        it('is an empty string', () => {
          expect(result).toEqual({ value: '' });
        });
      });

      describe('when there is no value', () => {
        inputWrapper.innerHTML = `
            <div>
              <input />
            </div>
          `;

        const input = inputForCustomFieldDefinition(definition, inputWrapper);

        it('is the input', () => {
          expect(input.nodeName).toEqual('INPUT');
          expect(input.value).toEqual('');
        });
      });
    });
  });

  describe('possibleRemainingSteps', () => {
    it('calculates simple path', () => {
      const elements = [
        {
          id: '1',
          formDefinitionRules: [
            {
              id: 'rule-1',
              ruleType: 'form',
              descendantFormDefinitionElementId: '2',
            },
          ],
        },
        {
          id: '2',
          formDefinitionRules: [
            {
              id: 'rule-2',
              ruleType: 'form',
              descendantFormDefinitionElementId: '3',
            },
            {
              id: 'rule-3',
              ruleType: 'form',
              descendantFormDefinitionElementId: '5',
            },
          ],
        },
        {
          id: '3',
          formDefinitionRules: [
            {
              id: 'rule-4',
              ruleType: 'form',
              descendantFormDefinitionElementId: '4',
            },
          ],
        },
        {
          id: '4',
          formDefinitionRules: [],
        },
        {
          id: '5',
          formDefinitionRules: [],
        },
      ];
      const element = elements[1];
      const visitedIds = [elements[0].id];

      expect(possibleRemainingSteps(element, elements, visitedIds)).toEqual(3);
    });

    it('handles cycle', () => {
      const elements = [
        {
          id: '1',
          formDefinitionRules: [
            {
              id: 'rule-1',
              ruleType: 'form',
              descendantFormDefinitionElementId: '2',
            },
          ],
        },
        {
          id: '2',
          formDefinitionRules: [
            {
              id: 'rule-2',
              ruleType: 'form',
              descendantFormDefinitionElementId: '1',
            },
            {
              id: 'rule-3',
              ruleType: 'form',
              descendantFormDefinitionElementId: '3',
            },
            {
              id: 'rule-4',
              ruleType: 'form',
              descendantFormDefinitionElementId: '5',
            },
          ],
        },
        {
          id: '3',
          formDefinitionRules: [
            {
              id: 'rule-5',
              ruleType: 'form',
              descendantFormDefinitionElementId: '4',
            },
          ],
        },
        {
          id: '4',
          formDefinitionRules: [],
        },
        {
          id: '5',
          formDefinitionRules: [],
        },
      ];
      const element = elements[1];
      const visitedIds = [elements[0].id];

      expect(possibleRemainingSteps(element, elements, visitedIds)).toEqual(3);
    });
  });
});
